import React from "react";
import withRequest from "../../hoc/withRequest";
import {Alert} from "../../components/common";
import {Backdrop, CircularProgress} from "@mui/material";
import ChangePasswordDumb from "./ChangePasswordDumb";
import {useUser} from "components/hooks";

const ChangePasswordSmart = () => {
  const { cleanPassword, editPassword, error, isLoaded, success, user } = useUser();

  const alerts = [
    {
      severity: 'info',
      open: success.password,
      message: 'changePassword.alert.success',
    },
    {
      severity: 'error',
      open: error.password,
      message: 'changePassword.alert.error',
    }
  ];

  const handleEdit = (data) => {
    editPassword({
      body: {
        username: user.username,
        oldPass: "Cordob12",
        newPass: "Cordob12"
      }
    })
  }

  return (
    <>
      { isLoaded.password ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ):
        (
          <ChangePasswordDumb handleOnSubmit={handleEdit} />
        )
      }
      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => cleanPassword()}
          open={alert.open}
          message={alert.message}
        />
      ))}
    </>
  );
}

export default withRequest(ChangePasswordSmart);
